import { render, staticRenderFns } from "./multiSelectUser.vue?vue&type=template&id=78979f9a"
import script from "./multiSelectUser.vue?vue&type=script&lang=js"
export * from "./multiSelectUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports